import React, { useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import propTypes from 'prop-types';
import { getNumberOfCarsPerPage } from '../../utilites';
import {
  NUMBER_OF_CARS_PER_PAGE,
  GRID_STYLE,
  None,
  DELAY,
  ANOTHER,
} from '../../constants';
import setShowCars from '../../redux/actions/carCard';
import Price from './price';
import LeaseCard from './leaseCard';

const CarCard = ({ cardBackground, isLeaseCardNeeds }) => {
  const cars = useSelector((state) => state.catalog.cars);
  const activePage = useSelector((state) => state.pagination.activePage);
  const pageViewStyle = useSelector((state) => state.catalogStyle.style);
  const showCarCards = useSelector((state) => state.catalog.showCarCards);
  const dispatch = useDispatch();
  const { dictionary, language } = startup;
  const start = activePage * NUMBER_OF_CARS_PER_PAGE;
  const carsToPage = cars.slice(start, getNumberOfCarsPerPage(cars, start));

  const leaseCardNumber =
    carsToPage.length !== NUMBER_OF_CARS_PER_PAGE ? 1 : (activePage % 2) + 1;

  if (isLeaseCardNeeds) carsToPage.splice(leaseCardNumber, 0, {});

  useLayoutEffect(() => {
    setTimeout(() => dispatch(setShowCars(true)), 0);
  }, [cars, activePage]);

  if (!cars.length) {
    return (
      <p className="text-center" style={{ width: '100%' }}>
        {dictionary.NotFound}
      </p>
    );
  }

  return carsToPage.map((item, idx) => {
    const classList =
      pageViewStyle === GRID_STYLE
        ? `b-goods-f ${cardBackground} col-lg-4 col-md-6 catalog-grid`
        : `b-goods-f ${cardBackground} col-12 b-goods-f_row catalog-row`;

    if (idx === leaseCardNumber && isLeaseCardNeeds)
      return (
        <LeaseCard
          classList={classList}
          key="leaseCard"
          cardNumber={leaseCardNumber}
        />
      );

    const title =
      item.Car.Model !== ANOTHER
        ? `${item.Car.Brand} ${item.Car.Model}`
        : item.Car.Brand;
    const mileage = `${item.Car.Mileage}km`;
    const price = item.Car.Price;
    const carStatus =
      item.Car.StatusId !== None ? dictionary[item.Car.StatusId] : None;
    const carStatusClassList =
      carStatus === None
        ? 'b-goods-f__label car-status d-none'
        : 'b-goods-f__label car-status';

    return (
      <CSSTransition
        key={item.Car.Id}
        in={showCarCards}
        timeout={DELAY + idx * 100}
        unmountOnExit // important!!!
        classNames="catalog"
      >
        <div className={classList}>
          <div className="b-goods-f__media overflow-hidden">
            <a
              href={`${window.location.origin}/${startup.language}/vehicle-details/${item.Car.Id}/${item.Car.Brand}-${item.Car.Model}`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="b-goods-f__img car-image"
                src={item.Images[0].FileName}
                alt={title}
              />
            </a>
            <span className="b-goods-f__media-inner">
              {item.Car.StatusId === 'Sold' ? (
                ''
              ) : (
                <span className="b-goods-f__favorite">
                  <a
                    href={`../../../${language}/leasing?carPrice=${item.Car.Price}&carId=${item.Car.Id}&carModel=${item.Car.Brand}-${item.Car.Model}`}
                  >
                    {dictionary.Leasing}
                  </a>
                </span>
              )}
              <span className={carStatusClassList}>{carStatus}</span>
            </span>
          </div>
          <div className="b-goods-f__main">
            <div className="b-goods-f__descrip">
              <div className="b-goods-f__title">{title}</div>
              <div className="b-goods-f__info">{item.Car.DescriptionLv}</div>
              <ul className="b-goods-f__list list-unstyled">
                <li className="b-goods-f__list-item">
                  <nobr>
                    <span className="b-goods-f__list-title">{`${dictionary.Mileage} :`}</span>
                  </nobr>
                  <span className="b-goods-f__list-info">{mileage}</span>
                </li>
                <li className="b-goods-f__list-item">
                  <nobr>
                    <span className="b-goods-f__list-title">{`${dictionary.Model} :`}</span>
                  </nobr>
                  <span className="b-goods-f__list-info">{item.Car.Year}</span>
                </li>
                <li className="b-goods-f__list-item">
                  <nobr>
                    <span className="b-goods-f__list-title">{`${dictionary.Transmission} :`}</span>
                  </nobr>
                  <span className="b-goods-f__list-info">
                    {dictionary[item.Car.TransmissionId]}
                  </span>
                </li>
                <li className="b-goods-f__list-item b-goods-f__list-item_row">
                  <nobr>
                    <span className="b-goods-f__list-title">{`${dictionary.BodyType} :`}</span>
                  </nobr>
                  <span className="b-goods-f__list-info">
                    {dictionary[item.Car.BodyId]}
                  </span>
                </li>
                <li className="b-goods-f__list-item">
                  <nobr>
                    <span className="b-goods-f__list-title">{`${dictionary.FuelType} :`}</span>
                  </nobr>
                  <span className="b-goods-f__list-info">
                    {dictionary[item.Car.EngineId]}
                  </span>
                </li>
                {/* <li className="b-goods-f__list-item b-goods-f__list-item_row">
                  <span className="b-goods-f__list-title">Engine Power:</span>
                  <span className="b-goods-f__list-info">160 hp</span>
                </li> */}
                <li className="b-goods-f__list-item b-goods-f__list-item_row">
                  <nobr>
                    <span className="b-goods-f__list-title">{`${dictionary.BodyColor} :`}</span>
                  </nobr>
                  <span className="b-goods-f__list-info">
                    {dictionary[item.Car.ColorId]}
                  </span>
                </li>
                {/* <li className="b-goods-f__list-item b-goods-f__list-item_row">
                  <span className="b-goods-f__list-title">Drive Type :</span>
                  <span className="b-goods-f__list-info">4WD</span>
                </li> */}
              </ul>
            </div>
            <Price status={item.Car.StatusId} price={price} />
          </div>
        </div>
      </CSSTransition>
    );
  });
};

export default CarCard;

CarCard.propTypes = {
  cardBackground: propTypes.string,
  isLeaseCardNeeds: propTypes.bool,
};

CarCard.defaultProps = {
  cardBackground: '',
  isLeaseCardNeeds: true,
};
